import PropTypes from 'prop-types';
import React from 'react';

import { Grid, Cell } from 'components/Grid';
import RichText from 'components/RichText';
import { small, mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

import Image from './Image';

const ArticlePageImageCopy = ({ image, imageMobile, copy }) => (
  <div className="ArticlePageImageCopy">
    <Grid isCentered>
      <Cell small={{ columns: 12 }} mediumUp={{ columns: 6 }}>
        <div className="ArticlePageImageCopy__image">
          <Image desktopImage={image} mobileImage={imageMobile} />
        </div>
      </Cell>
      <Cell
        className="ArticlePageImageCopy__copy"
        small={{ columns: 12 }}
        mediumUp={{ columns: 6 }}
      >
        <RichText content={copy} />
      </Cell>
    </Grid>

    <style jsx global>
      {`
        .ArticlePageImageCopy .AspectRatio {
          background-color: ${Theme.get('colors-grey')};
        }

        @media ${small} {
          .ArticlePageImageCopy__copy {
            padding-top: ${Theme.get('spacing') * 7}px;
          }
        }

        @media ${mediumUp} {
          .ArticlePageImageCopy {
            margin-bottom: ${Theme.get('spacing') * 5}px;
          }

          .ArticlePageImageCopy__image {
            padding-right: ${Theme.get('spacing') * 3}px;
          }

          .ArticlePageImageCopy__copy {
            padding-left: ${Theme.get('spacing') * 5}px;
          }
        }
      `}
    </style>
  </div>
);

const imagePropType = PropTypes.shape({
  file: PropTypes.shape({
    url: PropTypes.string,
  }),
  description: PropTypes.string,
});

ArticlePageImageCopy.propTypes = {
  image: imagePropType.isRequired,
  imageMobile: imagePropType,
  copy: PropTypes.shape({}).isRequired,
};

ArticlePageImageCopy.defaultProps = {
  imageMobile: null,
};

export default ArticlePageImageCopy;
